import { render, staticRenderFns } from "./ClubVideosView.vue?vue&type=template&id=68fda63d&"
import script from "./ClubVideosView.vue?vue&type=script&lang=js&"
export * from "./ClubVideosView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports